import { Schema } from 'effect';

import { GtmFormSubmittedEventSchema, type GtmFormType } from '@vs-shop/schemas/gtm/form-submitted';

export const createFormSubmittedPayload = (formName: GtmFormType, email: string) => {
  return Schema.decodeEffect(GtmFormSubmittedEventSchema)({
    event: 'form_submitted',
    form_name: formName,
    form_email: email,
  });
};
